<script setup lang="ts">
import type { EntityLocation } from "~/core/models/EntityLocation.interface";

const { t } = useI18n();

const model: Ref<EntityLocation> = defineModel<EntityLocation>({
  required: true,
});
const props = defineProps<{
  disabled: boolean;
}>();
</script>
<template>
  <p class="text-gray-700 mb-6 font-medium">
    {{ t("administration.entityLocation.location") }}
  </p>
  <div class="md:flex gap-x-8 lg:w-1/2">
    <lxc-form-item
      :label="t('administration.entityLocation.country')"
      class="md:basis-1/2"
      prop="country"
    >
      <country-component v-model="model.country" :disabled="props.disabled" />
    </lxc-form-item>
    <lxc-form-item
      :label="t('administration.entityLocation.latitude')"
      prop="latitude"
      class="md:basis-1/4"
    >
      <lxc-input
        v-model="model.latitude"
        type="number"
        :disabled="props.disabled"
      />
    </lxc-form-item>
    <lxc-form-item
      :label="t('administration.entityLocation.longitude')"
      class="md:basis-1/4"
      prop="longitude"
    >
      <lxc-input
        v-model="model.longitude"
        type="number"
        :disabled="props.disabled"
      />
    </lxc-form-item>
  </div>
  <lxc-form-item
    :label="t('administration.entityLocation.timezone')"
    class="md:w-[calc(25%-32px)]"
    prop="timezone"
  >
    <timezone-component v-model="model.timezone" :disabled="props.disabled" />
  </lxc-form-item>
</template>
